import React from 'react';
import {
  SociogramPage,
  SociogramPageById,
  SociogramFinishedPage,
} from '@BUP/pages';
import { Switch, useRouteMatch } from 'react-router-dom';
import { RoleRoute } from '@BUP/routes';

const SociogramNavigation = () => {
  const match = useRouteMatch();
  return (
    <Switch>
      <RoleRoute
        name="SociogramPage"
        component={SociogramPage}
        path="/data/sociogram"
        exact
      />
      <RoleRoute
        name="SociogramFinishedPage"
        component={SociogramFinishedPage}
        path="/data/sociogram/finish"
        exact
      />
      <RoleRoute
        name="SociogramPageById"
        component={SociogramPageById}
        path={`${match.path}/:pageId`}
      />
    </Switch>
  );
};

export default SociogramNavigation;
